import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { CreationContext } from '../InvoiceCreation';
import Heading from '../../../../generic-components/Heading';
import Button from '../../../../generic-components/Button';
import { STYLES } from '../consts/consts';
import { LinkShareWrapper } from './LinkShareWrapper';
import { CloseButton } from '../../../../DesignSystem/LiliCloseButton/CloseButton';
import { ReactComponent as PenIcon } from '../../../../assets/svg/edit-pen.svg';

const { INVOICE_CREATION: { INVOICE_PREVIEW } } = STYLES;

interface IProps {
  handleClick: (type: string) => void;
  isLoading?: boolean;
  shouldShowCopy?: boolean;
    isSubmitAble?: boolean;
}

export const SliderUserMessage = ({
  handleClick, isLoading, shouldShowCopy, isSubmitAble,
}: IProps) => {
  const contextData = useContext(CreationContext);
  const { t } = useTranslation();

  return (
    <div className={INVOICE_PREVIEW.CONTAINER}>

      {shouldShowCopy && <LinkShareWrapper onCloseShare={() => handleClick('CLOSE')} />}

      <div className={INVOICE_PREVIEW.HEADER_WRAPPER}>
        <CloseButton onClick={() => handleClick('CLOSE-ICON')} id='closeButton' className='z-50' />
      </div>
      <div className={INVOICE_PREVIEW.IFRAME_WRAPPER}>
        <iframe className={INVOICE_PREVIEW.IFRAME} title={t('INVOICE_CREATION.INVOICE_CLIENT_SECTION.INVOICE_PREVIEW.IFRAME_TITLE')} src={contextData?.iFrameUrl} />
      </div>

      <div className={INVOICE_PREVIEW.FOOTER_WRAPPER}>
        {!contextData.isInvoiceCreated && (
        <div className={INVOICE_PREVIEW.DISCLAIMER_WRAPPER}>
          <Heading title={t('INVOICE_CREATION.INVOICE_CLIENT_SECTION.INVOICE_PREVIEW.DISCLAIMER_HEADER')} className={INVOICE_PREVIEW.DISCLAIMER} />
        </div>
        )}
        { !contextData.isInvoiceCreated && (
        <div className={INVOICE_PREVIEW.ACTIONS_WRAPPER}>
          <Button
            className={INVOICE_PREVIEW.ACTIONS_CONTINUE_EDIT}
            id=''
            childElement={(
              <div className='flex flex-row'>
                <PenIcon className='text-action03' />
                <Heading
                  title={t('INVOICE_CREATION.INVOICE_CLIENT_SECTION.INVOICE_PREVIEW.ACTION_CONTINUE_EDIT')}
                  className={INVOICE_PREVIEW.ACTIONS_CONTINUE_EDIT_TITLE}
                />
              </div>
                  )}
            onClick={() => handleClick('CLOSE')}
          />
          <Button
            disable={!isSubmitAble}
            isLoading={contextData.isLoading || isLoading}
            onClick={() => handleClick('CREATE_INVOICE')}
            className={isSubmitAble ? INVOICE_PREVIEW.ACTIONS_CREATE_INVOICE : INVOICE_PREVIEW.ACTIONS_CREATE_INVOICE_DISABLE}
            id=''
            childElement={(contextData.isLoading || isLoading) ? '' : <Heading title={t('INVOICE_CREATION.INVOICE_CLIENT_SECTION.INVOICE_PREVIEW.ACTION_CREATE_INVOICE')} className={isSubmitAble ? INVOICE_PREVIEW.ACTIONS_CREATE_INVOICE_TITLE : INVOICE_PREVIEW.ACTIONS_CREATE_INVOICE_TITLE_DISABLED} />}
          />
        </div>
        )}
      </div>
    </div>
  );
};
